import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

import { Course } from "./../../shared/models/course";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-courses",
  templateUrl: "./courses.component.html",
})
export class CoursesComponent implements OnInit, OnDestroy {
  courseList: Course[];
  showNoCourseMessage: boolean = false;
  private destroy$ = new Subject<void>();

  @Input() courses: BehaviorSubject<Course[]>;
  @Input() ccpAudit: boolean;
  @Output() onCourseDeleted: EventEmitter<string> = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.courses.pipe(takeUntil(this.destroy$)).subscribe((c) => {
      if (!c || c.length === 0) {
        this.showNoCourseMessage = true;
      } else {
        this.showNoCourseMessage = false;
      }

      this.courseList = c;
    });
  }

  deleteCourse(courseId: string) {
    this.onCourseDeleted.emit(courseId);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
